import { render } from "./TemplateSetPicker.vue?vue&type=template&id=00890a9e&ts=true"
import script from "./TemplateSetPicker.vue?vue&type=script&lang=ts"
export * from "./TemplateSetPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__